/* eslint-disable @typescript-eslint/no-explicit-any */
import { KubernetesObject } from "@kubernetes/client-node"
import { K8SResourceType, OperateFunction, PlanContextData } from "yam-types"
import { Settings } from "../settings.d"
import { AppMonitor } from "../types.d"

let defaultServiceMonitorLabels = {
  "release": "prometheus"
}
const PROM_OPERATOR_API_GROUP = "monitoring.coreos.com"
const DEFAULT_METRICS_INTERVAL = 30

const monitorOperator: OperateFunction<AppMonitor> = async (plan, diff, settings: Settings) => {
  defaultServiceMonitorLabels = Object.assign(defaultServiceMonitorLabels, settings.serviceMonitorLabels)
  if (!diff.hasDiff) {
    plan.log.info(`no diff found for monitoring part, skipped`)
    return
  }
  const monitors = diff.currentItems.filter(x => x.enable !== false)
  if (monitors.length === 0 && diff.deletedItems.length === 0) {
    plan.log.info(`no content found for monitoring part, skipped`)
    return
  }

  monitors.forEach(monitor => {
    const serviceMonitor = composeServiceMonitor(plan.data, monitor, settings)
    const name = serviceMonitor.metadata?.name
    plan.action(async (ctx) => {
      if (!ctx.k8sClient.crdExists(K8SResourceType.ServiceMonitor, PROM_OPERATOR_API_GROUP)) {
        ctx.log.error("Prometheus Operator CRD isn't installed, plugin will not take effect")
        return
      }
      ctx.mergeToYaml({
        name: "service-monitor-" + name,
        content: serviceMonitor
      })
    }, "sync-service-monitor:" + name)
  })

  // When the whole monitor part is deleted
  diff.deletedItems.forEach(monitor => {
    const deletedMonitor = composeServiceMonitor(plan.data, monitor, settings)
    const name = deletedMonitor.metadata?.name
    plan.action(async (ctx) => {
      if (!ctx.k8sClient.crdExists(K8SResourceType.ServiceMonitor, PROM_OPERATOR_API_GROUP)) {
        ctx.log.error("Prometheus Operator CRD isn't installed, plugin will not take effect")
        return
      }
      await ctx.k8sClient.delete({
        name,
        kind: K8SResourceType.ServiceMonitor
      })
    }, "delete-service-monitor:" + name)
  })
}

const composeServiceMonitor = (planData: PlanContextData, monitor: AppMonitor, settings: Settings): KubernetesObject => {
  const defaultPort = (planData.currentModelFull?.access as any)?.[0].containerPort ||
    (planData.currentModelFull?.deploy as any)?.containers[0]?.port || 80
  return {
    kind: K8SResourceType.ServiceMonitor,
    metadata: {
      name: planData.workloadName,
      labels: Object.assign({ workload: planData.workloadName }, defaultServiceMonitorLabels)
    },
    spec: Object.assign({}, monitor.serviceMonitorSpec, {
      selector: {
        matchLabels: {
          workload: planData.workloadName,
          [settings.serviceAliasLabelNameForSelector || 'service-alias-name']: monitor.serviceName
        }
      },
      endpoints: [{
        port: monitor.port ? monitor.port.toString() : undefined,
        targetPort: monitor.port ? undefined : (monitor.targetPort || defaultPort),
        path: monitor.path || '/metrics',
        interval: monitor.interval || ((monitor.intervalSeconds || settings.defaultIntervalSeconds || DEFAULT_METRICS_INTERVAL) + 's'),
      }]
    })
  } as KubernetesObject
}

export default monitorOperator